// extracted by mini-css-extract-plugin
export default {"custom-pagination-style":"BasePagination-1Y5qk__custom-pagination-style","pagination":"BasePagination-mjkaa__pagination"};